<template>
  <div class="d-flex gap-2 align-items-center flex-wrap">
    <div
      v-if="isLoading"
      class="w-100 d-flex justify-content-center"
    >
      <b-spinner></b-spinner>
    </div>
    <template v-else>
      <TaggingBadge
        v-for="tag in featuredTags"
        :key="tag.id"
        :label="tag.name"
        :variant="tag.color_variant"
      />
    </template>
  </div>
</template>

<script>
  import { suppliosApi } from '@/js/api-service';
  import TaggingBadge from './TaggingBadge.vue';

  export default {
    name: 'TagFieldLocationDisplay',
    components: {
      TaggingBadge,
    },
    props: {
      value: { type: Object, required: false },
      locationSlug: { type: String, required: true },
    },
    data() {
      return {
        isLoading: false,
        tagFieldById: {},
      };
    },
    methods: {
      async getTagFieldLocations() {
        this.isLoading = true;
        const { data } = await suppliosApi.tags.tagFieldLocation.getByLocationSlug(this.locationSlug);
        for (const tagFieldLocation of data) {
          this.$set(this.tagFieldById, tagFieldLocation.tag_field.id, tagFieldLocation.tag_field);
        }
        console.log('from featured taggings location - this.tagFieldById', this.tagFieldById);
      },
    },
    computed: {
      featuredTags() {
        // Get all tags from the value object
        const tags = [];

        for (const tfId in this.tagFieldById) {
          if (this.value[tfId]) {
            tags.push(...this.value[tfId]);
          }
        }

        return tags;
      },
    },
    created() {
      this.getTagFieldLocations().finally(() => {
        this.isLoading = false;
      });
    },
  };
</script>

<style></style>
